<div class="flex-vertical gap-16">
  @if (!isLoading) {
    <div class="filters-container">
      <div class="flex-horizontal gap-16 width-100pc">
        @if (isFilterActive(operationDashboardFilterEnum.Investisseur)) {
          <app-search-investisseur-autocomplete
            class="searchbar"
            [initInvestisseur]="selectedInvestisseurAll"
            (onInvestisseurPersonneSelected)="onInvestisseurAllSelected($event)"
            [fullDisplay]="isBackOffice"
            label="Investisseur">
          </app-search-investisseur-autocomplete>
        }
        @if (isFilterActive(operationDashboardFilterEnum.InvestisseurPersonnePhysique)) {
          <app-search-investisseur-personnes-physiques
            class="searchbar"
            [initInvestisseur]="selectedInvestisseurPhysique"
            (onInvestisseurPersonneSelected)="onInvestisseurPhysiqueSelected($event)"
            [fullDisplay]="isBackOffice"
            label="Investisseur (personne physique)">
          </app-search-investisseur-personnes-physiques>
        }
        @if (isFilterActive(operationDashboardFilterEnum.InvestisseurPersonneMorale)) {
          <app-search-investisseur-personnes-morales
            class="searchbar"
            [initInvestisseur]="selectedInvestisseurMorale"
            (onInvestisseurPersonneSelected)="onInvestisseurMoraleSelected($event)"
            [fullDisplay]="isBackOffice"
            label="Investisseur (personne morale)">
          </app-search-investisseur-personnes-morales>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Consultant)) {
          <lib-search-consultant-autocomplete
            class="searchbar"
            [initConsultant]="selectedConsultant"
            (onConsultantSelected)="onConsultantSelected($event)"
          label="Consultant"></lib-search-consultant-autocomplete>
        }
        @if (isFilterActive(operationDashboardFilterEnum.NumeroContrat)) {
          <lib-search-commande-autocomplete
            [initCommande]="selectedContrat"
            (onCommandeSelected)="onContratSelected($event)"
          class="searchbar"></lib-search-commande-autocomplete>
        }
        @if (isFilterActive(operationDashboardFilterEnum.GoToById)) {
          <div
            class="flex-1 flex-horizontal gap-8 width-100pc"
            >
            <oui-textfield
              iconSuffix="arrow_forward"
              label="ID d'opération"
              [control]="goToOperationIdControl"
              (enter)="goToOperation()"
              (suffixIconClick)="goToOperation()"
              [(value)]="goToOperationId"
            class="flex-1"></oui-textfield>
          </div>
        }
        @if (isLoading) {
          <oui-loading class="flex-vertical flex-center align-self-center"></oui-loading>
        }
      </div>
      <div class="flex-horizontal gap-16 flex-wrap">
        @if (isFilterActive(operationDashboardFilterEnum.Statut)) {
          <oui-select-filter
            label="Statut"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="statutOptions"
          [control]="statutControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Enveloppe)) {
          <oui-select-filter
            label="Enveloppe"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="enveloppeOptions"
          [control]="enveloppeControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Nature)) {
          <oui-select-filter
            label="Nature"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="natureOperationOptions"
          [control]="natureOperationControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Produit)) {
          <oui-select-filter
            label="Produit"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="produitOptions"
          [control]="produitControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Montant)) {
          <oui-select-filter
            label="Montant"
            type="range"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [rangeUnit]="'€'"
          [control]="montantControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Gestionnaire)) {
          <oui-select-filter
            label="Gestionnaires"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="gestionnaireOptions"
          [control]="gestionnaireControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.FondEvnt)) {
          <oui-select-filter
            label="Fonds évenementiels"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="fondsEvntOptions"
          [control]="fondsEvntControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Tag)) {
          <oui-select-filter
            label="Tag"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="tagOptions"
          [control]="tagControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Signature)) {
          <oui-select-filter
            label="Signature"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="signatureOptions"
          [control]="signatureControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.ErrorPartenaireEmail)) {
          <oui-select-filter
            label="Problème e-mail partenaire"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="errorEmailOptions"
          [control]="errorEmailControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.CommandeAramis)) {
          <oui-select-filter
            label="Commande Aramis"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="commandeAramisOptions"
          [control]="commandeAramisControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.IsInvestisseurPersonneMorale)) {
          <oui-select-filter
            label=" Type d'investisseur"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="isInvestisseurPersonneMoraleOptions"
          [control]="isInvestisseurPersonneMoraleControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.ModePaiement)) {
          <oui-select-filter
            label="Mode de paiement"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="modePaiementOptions"
          [control]="modePaiementControl"></oui-select-filter>
        }
        @if (isFilterActive(operationDashboardFilterEnum.Demembrement)) {
          <oui-select-filter
            label="Démembrement"
            type="list"
            panelDirection="left"
            listPlaceholder="Rechercher"
            [listOptions]="demembrementOptions"
          [control]="demembrementControl"></oui-select-filter>
        }
      </div>
      <div class="flex-horizontal gap-16 flex-wrap">
        @if (isFilterActive(operationDashboardFilterEnum.CreationDateRange)) {
          <oui-range-date-picker
            label="Date de création"
          [control]="creationDateRangeControl"></oui-range-date-picker>
        }
        @if (isFilterActive(operationDashboardFilterEnum.UpdateDateRange)) {
          <oui-range-date-picker
            label="Date de mise à jour"
          [control]="updateDateRangeControl"></oui-range-date-picker>
        }
      </div>
    </div>
  }
  <div class="flex-horizontal gap-16">
    <oui-chip-list type="selection">
      @for (filter of filterStateMap | keyvalue; track filter) {
        @for (chip of filter.value.chips; track chip) {
          <oui-chip (remove)="onRemove(chip)">{{ chip.label }}</oui-chip>
        }
      }
    </oui-chip-list>
    @if (showClearFiltersButton) {
      <oui-button type="text" color="primary" (click)="onclearAllFilter()"
        >Effacer les filtres
      </oui-button>
    }
  </div>
</div>
